import React, { memo, useContext, useState } from 'react'
import { SPContext } from '../../SPContext'
import PageLoading from '../helpers/PageLoading'
import { Row, Col, Form, Input, Button } from 'reactstrap'
import Axios from 'axios'

const CommentInput = memo(
  ({
    uri,
    users,
    user_id,
    token,
    ev_comment,
    ev_comments,
    setComments,
    event,
    rows_size,
    fnCancel,
  }) => {
    const [save_button_disabled, setSaveButtonDisabled] = useState(false)
    const [event_comment_text, setEventCommentText] = useState('')

    const onChangeField = target => {
      setEventCommentText(target.value)
    }

    const handleCancel = e => {
      setEventCommentText('')
      fnCancel && fnCancel(e)
    }

    const onSubmitEventCommentForm = e => {
      e.preventDefault()

      setSaveButtonDisabled(true)

      let data = new FormData()
      data.append('token', token)
      data.append('event_comment_FK_event_id', event.event_id)
      data.append('event_comment_text', event_comment_text)
      data.append(
        'event_comment_FK_parent_event_comment_id',
        (ev_comment && ev_comment.event_comment_id) || 0,
      )

      Axios.post(`${uri}Event_Comment/save`, data)
        .then(response => {
          setEventCommentText('')

          setSaveButtonDisabled(false)
          setComments(response.data.data)

          const ehacked = { target: { textContent: '' } }
          handleCancel(ehacked)
        })
        .catch(err => {
          console.log(err)
        })
    }

    if (!event || !ev_comments) return <PageLoading />

    return (
      <Row className='mt-2  mb-4'>
        <Col md='2' className='sp-comment-input'>
          <img
            width={50}
            height={50}
            src={
              '/timthumb.php?width=50&height=50&src=https://socialfiles.blob.core.windows.net/staff/' +
              user_id +
              '.jpg'
            }
            alt="I'm going"
          />
        </Col>
        <Col md='10' className='sp-comment-input'>
          <Form onSubmit={onSubmitEventCommentForm}>
            <Input
              type='textarea'
              rows={rows_size}
              value={event_comment_text}
              name='event_comment_text'
              onChange={e => onChangeField(e.target)}
              required
            />
            <Row>
              <Col className='mt-2 text-right'>
                <Button
                  color='secondary'
                  size='sm'
                  onClick={e => handleCancel(e)}
                >
                  Cancel
                </Button>{' '}
                <Button
                  type='submit'
                  color='success'
                  size='sm'
                  disabled={save_button_disabled}
                >
                  Comment
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    )
  },
)

const CommentInputContainer = props => {
  const { uri, users, user_id, token } = useContext(SPContext)
  return (
    <CommentInput
      uri={uri}
      users={users}
      user_id={user_id}
      token={token}
      {...props}
    />
  )
}

export default CommentInputContainer
